import React from 'react';
const Notifications = () => <div className="p-8"><h1 className="text-2xl font-bold">Notifications Page</h1></div>;
export default Notifications; 